import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import StarIcon from "../../assets/svgs/common/star.svg";
import type {
	FieldValues,
	Path,
	PathValue,
	UseFormReturn,
} from "react-hook-form";
import { Button } from "../ui/button";
import { Uploader } from "../custom/uploader";
import UploadIcon from "../../assets/svgs/common/upload.svg";
import DeleteIcon from "../../assets/svgs/common/delete.svg";
import DocumentSmall from "../../assets/svgs/campaigns/doc.svg";

type FormInputProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label: string;
	required?: boolean;
	maxSize?: number;
	onValueChange: (files: File[]) => void;
};

export const FormImageUpload = <T extends FieldValues>({
	form,
	name,
	label,
	required,
	maxSize,
	onValueChange,
}: FormInputProps<T>) => {
	const { setValue } = form;

	const handleValueChange = (files: File[]) => {
		const fileObjects = files.map((file) => ({ file }));

		setValue(name, fileObjects as PathValue<T, Path<T>>, { shouldDirty: true }); // Manually mark field as dirty
		onValueChange(fileObjects.map((fileObject) => fileObject.file));
	};

	const handleRemove = () => {
		// Remove all files and mark as non-dirty
		setValue(name, [] as PathValue<T, Path<T>>, { shouldDirty: false });
		// onValueChange([]);
	};

	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label} {required && <StarIcon />}
					</FormLabel>
					<FormControl>
						{field.value && field.value.length > 0 ? (
							<div className="flex justify-between items-center py-6 pl-4 border border-border rounded-xl h-16 font-semibold">
								<div className="flex items-center gap-2">
									<DocumentSmall />
									<p className="w-80 text-nowrap text-sm truncate overflow-hidden">
										{" "}
										{field.value[0].file.name}{" "}
									</p>
								</div>
								<Button
									type="button"
									onClick={handleRemove}
									className="bg-transparent"
								>
									<DeleteIcon />
								</Button>
							</div>
						) : (
							<Uploader
								value={field.value}
								onValueChange={handleValueChange}
								maxSize={maxSize}
								accept={{
									"image/jpg": [],
									"image/jpeg": [],
									"image/png": [],
								}}
								className="flex gap-1 py-6 pl-6 border border-border rounded-xl h-16 font-semibold text-secondary cursor-pointer"
							>
								<UploadIcon />
								<p className="text-sm leading-5">Select image</p>
							</Uploader>
						)}
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
